import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import { TCreateNewAdminReduxParams } from '~types/feat/admin';

import Modal from '~components/atoms/Modal';
import AdminsCreateAdminForm from '../AdminsCreateAdminForm';

const AdminsCreateAdminModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.admin.modals.createNewAdminModalIsOpen);
    const isLoading = useAppSelector(state => state.admin.loadings.createNewAdmin);
    const error = useAppSelector(state => state.admin.errors.createNewAdmin);

    const handleModalOnClose = () => {
        dispatch(combinedActions.adminResetCreateNewAdminState());
        dispatch(combinedActions.adminSetCreateNewAdminModalIsOpen(false));
    };

    const handleOnSubmit = (data: TCreateNewAdminReduxParams) => !isLoading && dispatch(combinedActions.adminCreateNewAdminAttempt(data));

    return (
        <Modal
            title='Create User'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <AdminsCreateAdminForm
                submitButtonLabel='Create User'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
            />
        </Modal>
    );
};

export default AdminsCreateAdminModal;
